import { ref, onValue } from 'firebase/database';
import StartFirebase from './index';

const db = StartFirebase();

export const fetchData = async() => {
    let records = [];
    onValue(ref(db), (snapshot) => {
        Object.keys(snapshot.val()).forEach((key) => {
            const snapshotData = snapshot.val()[key];

            if(snapshotData.count%2 !== 0) {
                records.push({"key": key,"data": snapshotData});
            }    
        });
    });

    return records;
}